import React, { useState } from 'react';
import './BitDetailedViewCard.css';
import sampleImage from './image/food-img.png';
import vegLogo from './image/veg-logo.svg';
import { CiForkAndKnife } from "react-icons/ci";
import { BiDrink } from "react-icons/bi";
import { BiMale } from "react-icons/bi";
import { FaFemale } from "react-icons/fa";
import { BiMaleFemale } from "react-icons/bi";
import { FaChildReaching } from "react-icons/fa6";
import { MdPets } from "react-icons/md";
import image1 from '../MenuPage/image/food1.jpg';
import { MdAccessTime } from "react-icons/md";
import { MdMicExternalOn } from "react-icons/md";

import { MdNoDrinks } from "react-icons/md";
import MenuItemCard from '../MenuPage/custom-comp/MenuItemCard';
import BidGallery from './BidGallery';
import CollapsibleMenuSection from './CollapsibleMenuSection';
import BidEventsCard from './BidEventsCard';
import { API_BASE_URL } from '../utils';

const tabs = ['Party Details', 'Menu', 'Gallery', 'Events'];

// const mockMenu = [
//   { id: 1, name: 'Corn Chaat', category: 'Starters', description: 'Corn Chaat is a deliciousv sjvcs fgfbbfnfnc svdhsv ajbbds bsbcsb hdjbjkbv', image: image1 },
//   { id: 2, name: 'Veg Soup', category: 'Soup', description: 'Corn Chaat is a deliciousv sjvcs fgfbbfnfnc svdhsv ajbbds bsbcsb hdjbjkbv  ', image: image1 },
//   { id: 3, name: 'Paneer Tikka', category: 'Starters', description: 'Corn Chaat is a deliciousv sjvcs fgfbbfnfnc svdhsv ajbbds bsbcsb hdjbjkbv ', image: image1 },
// ];

const BitDetailedViewCard = ({ formattedData, selectedCard, gallery, events, packageDetails }) => {

  const url = `${API_BASE_URL}/master/assets/uploads/`;
  const [activeTab, setActiveTab] = useState('Party Details');

  const partydetails = () => {
    if (!formattedData) return {};

    return {
      MainCourse: formattedData.veg.MainCourse.choice === "All"
        ? formattedData.veg.MainCourse.items.length
        : parseInt(formattedData.veg.MainCourse.choice || 0),

      Starters: formattedData.veg.Starters.choice === "All"
        ? formattedData.veg.Starters.items.length
        : parseInt(formattedData.veg.Starters.choice || 0),

      drinks: formattedData.drinks.Cocktails.choice === "All"
        ? formattedData.drinks.Cocktails.items.length
        : parseInt(formattedData.drinks.Cocktails.choice || 0),

      SoftDrinks: formattedData.drinks.SoftDrinks.choice === "All"
        ? formattedData.drinks.SoftDrinks.items.length
        : parseInt(formattedData.drinks.SoftDrinks.choice || 0)
    };
  };

  const details = partydetails();

  console.log("gallery", gallery);


  return (
    <>
      <div className="party-card">
        <div className="party-image-container">
          <img src={url + selectedCard?.clubLogo} alt="Party" className="party-image" />
          <div className="badges">
            <span className="badge gray"><MdNoDrinks /> Non - Alcoholic</span>
            <span className="badge green"><span><img src={vegLogo} alt="" /></span> Pure Veg</span>
          </div>
        </div>

        <div className="tabs">
          {tabs.map((tab) => (
            <div
              key={tab}
              className={`tab-item ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </div>
          ))}
        </div>

        {activeTab === 'Party Details' && (
          <div className="party-details">

            <ul className="details-list">
              <li><CiForkAndKnife /> Food - {details.Starters} Starters + {details.MainCourse} Main Course</li>
              <li><BiDrink /> Drinks - {details.drinks} Mocktails + {details.SoftDrinks} Soft drinks</li>
              <li><BiMale /> Male stag allowed</li>
              <li><FaFemale /> Female stag allowed</li>
              <li><BiMaleFemale /> Couples Friendly</li>
              <li><FaChildReaching /> Kids Friendly</li>
              <li><MdPets /> Pets Friendly</li>
              <li><MdAccessTime /> Alcohol Serving Time - {packageDetails?.alcoholserving}</li>
              <li><MdAccessTime /> Food Serving Time - {packageDetails?.foodserving}</li>
              <li><MdMicExternalOn /> Live Music</li>
            </ul>
          </div>
        )}

        {activeTab === 'Menu' && formattedData && (
          <div className="bdvc-menu-section">
            {/* Veg Menu */}
            <div className="bdvc-menu">
              <h5>Veg Menu</h5>
              {Object.entries(formattedData.veg).map(([category, { items, choice, image }]) => (
                <CollapsibleMenuSection
                  key={category}
                  title={`${category} (Choose ${choice})`}
                  items={items}
                  image={image}
                  isveg={true}
                />
              ))}
            </div>

            {/* Non-Veg Menu */}
            <div className="bdvc-menu">
              <h5>Non-Veg Menu</h5>
              {Object.entries(formattedData.nonVeg).map(([category, { items, choice, image }]) => (
                <CollapsibleMenuSection
                  key={category}
                  title={`${category} (Choose ${choice})`}
                  items={items}
                  image={image}
                  isveg={false}
                />
              ))}
            </div>

            {/* Drinks Menu */}
            <div className="bdvc-menu">
              <h5>Drinks</h5>
              {Object.entries(formattedData.drinks).map(([category, { items, choice, image }]) => (
                <CollapsibleMenuSection
                  key={category}
                  title={`${category} (Choose ${choice})`}
                  items={items}
                  image={image}
                />
              ))}
            </div>
          </div>
        )}


        {activeTab === 'Gallery' && (
          <>
            <div className='bdvc-menu-section'>
              <div className='bdvc-menu'>
                {gallery.length === 0 ? (
                  <p className='no-images-data'>No images to show</p>
                ) : (
                  gallery.map((categoryItem, catIndex) => (
                    <BidGallery key={catIndex} gallery={categoryItem} />
                  ))
                )}
              </div>
            </div>

          </>)}

        {activeTab === 'Events' && (
          <div className='bdvc-events'>
            <BidEventsCard events={events} />
          </div>
        )}
      </div>
    </>

  );
};

export default BitDetailedViewCard;
